import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { reportErrorSchema } from '@schemas/questions/questions.schema'
import { questionsAPI } from '@services/QuestionsAPI'

import { Button } from '../Button'
import { TextArea } from '../TextArea'
import { questionReportErrorStyles } from './styles'

const { containerReportError, commentButton } = questionReportErrorStyles

type FormCommentValue = {
	message: string
}

type QuestionInfo = {
	id: number
}

export type ErrorSelectType = {
	error: { value: string; label: string }
}

export function QuestionReportError({ id }: QuestionInfo) {
	const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm<FormCommentValue>({ resolver: yupResolver(reportErrorSchema) })

	const [createQuestionReportError, { isSuccess, isLoading }] =
		questionsAPI.usePostReportErrorQuestionMutation()

	const onSubmitComment = handleSubmit((payload) => {
		createQuestionReportError({
			questionId: id,
			message: payload.message,
			appVersion: 'Web',
			errorType: 'answer_error',
			answerWrong: true,
			osVersion: 'Web',
		})
	})

	useEffect(() => {
		if (isSuccess) {
			reset()
		}
	}, [reset, isSuccess])

	return (
		<>
			<form className={containerReportError()} onSubmit={onSubmitComment}>
				<TextArea
					placeholder='Descreva brevemente sobre o que está acontecendo...'
					css={{ borderColor: '$neutral50', minHeight: '92px' }}
					error={errors.message?.message}
					{...register('message')}
				/>

				<div className={commentButton()}>
					<Button
						css={{ '@md': { maxWidth: '219px' } }}
						loading={isLoading}
						disabled={isLoading}
					>
						Reportar erro
					</Button>
				</div>
			</form>
		</>
	)
}
